import { sendEmailVerification } from "firebase/auth";

const records = new Map();
const pending = new Map();
export const VERIFICATION_DELIVERY_EVENT = "lightly-verification-delivery";
export function verificationDeliveryFor(uid) {
  return records.get(uid) || null;
}
export function verificationErrorMessage(error) {
  const code = String(error?.code || "");
  const messages = {
    "auth/too-many-requests": "Too many requests. Wait a minute before asking for another email.",
    "auth/quota-exceeded": "The email service has reached its sending limit. Please contact support.",
    "auth/network-request-failed": "We couldn't reach the email service. Check your connection and try again.",
    "auth/user-token-expired": "Your sign-in session has expired. Sign out and sign in again, then resend the email.",
    "auth/invalid-user-token": "Your sign-in session is no longer valid. Sign out and sign in again, then resend the email.",
    "auth/user-disabled": "This account is disabled. Please contact your administrator.",
    "auth/unauthorized-continue-uri": "Verification emails are not configured for this website. Please contact support.",
    "auth/invalid-continue-uri": "The verification return address is invalid. Please contact support.",
  };
  const message = messages[code] || "We couldn't send the verification email. Please try again shortly.";
  // Never render server messages: they can contain addresses, tokens or URLs.
  const reference = /^auth\/[a-z-]{1,60}$/.test(code) ? ` Reference: ${code}.` : "";
  return message + reference;
}

export function requestVerificationEmail(user, settings) {
  // Only coalesce identical requests: another church or destination must keep
  // its own continuation link, even when the signed-in account is the same.
  const key = JSON.stringify([user.uid, settings]);
  if (pending.has(key)) return pending.get(key);
  const publish = (status, code = "") => {
    records.set(user.uid, { status, code });
    window.dispatchEvent(new CustomEvent(VERIFICATION_DELIVERY_EVENT));
  };
  const request = Promise.resolve().then(async () => {
    try {
      // Refresh the existing session, never impersonate the user or bypass a
      // revoked/expired sign-in. Do not report success until sending succeeds.
      await user.getIdToken(true);
      await sendEmailVerification(user, settings);
      publish("accepted");
    } catch (error) {
      const code = String(error?.code || "");
      publish("failed", /^auth\/[a-z-]{1,60}$/.test(code) ? code : "");
      throw error;
    } finally {
      pending.delete(key);
    }
  });
  pending.set(key, request);
  publish("sending");
  return request;
}
